import Repository from '@/libs/axios'

const resource = '/mcp'

export default {
  getPermissions() {
    return Repository.get(`${resource}/permissions`)
  },
  getConnections() {
    return Repository.get(`${resource}/connections`)
  },
  revokeConnection(grantId) {
    return Repository.post(`${resource}/connections/revoke`, { grant_id: grantId })
  },
  getMyAudit(params) {
    return Repository.get(`${resource}/audit/me`, { params })
  },
  getAdminAudit(params) {
    return Repository.get(`${resource}/admin/audit`, { params })
  },
  getConsentInfo(params) {
    return Repository.get(`${resource}/oauth/consent`, { params })
  },
  submitConsent(payload) {
    return Repository.post(`${resource}/oauth/consent`, payload)
  },
}
